import { UcoastEl } from '@/scripts/core/UcoastEl'
import { qsOptional, qsRequired } from '@/scripts/core/global'

export class CustomAfterpay extends UcoastEl {
	static htmlSelector = 'custom-afterpay'
	opener: HTMLButtonElement
	constructor() {
		super()
		this.opener = qsRequired('[data-opener]', this)
		this.opener.addEventListener('click', this.onOpenerClick.bind(this))
	}
	onOpenerClick() {
		const afterpayElement = qsOptional('square-placement')
		if (!afterpayElement) {
			console.log('no modal')
			return
		}
		const shadowRoot = afterpayElement.shadowRoot;
		if (!shadowRoot) {
			console.log('no shadowRoot')
			return
		}
		const logoLink: HTMLButtonElement | null = shadowRoot.querySelector('#logo-link');
		if (!logoLink) {
			console.log('no logoLink')
			return
		}
		console.log('bmpn that', logoLink)
		logoLink.click()
	}
}
